/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { colors } from 'features/userData/style';
import * as geoConfig from 'config/geocoder/config';
import { Button, MenuItem, Stack, Menu } from '@mui/material';
import { styled } from '@mui/system';

const SearchAndDownloadButtons = ({ 
    showReverse, 
    handleQuery, 
    downloadOptions, 
    address, 
    revX, 
    revY, 
    handleDownloadItemClick,
    startIconName,
    panelMode,
    canDownload
}) => {
    const [dropdownEl, setDropdownEl] = useState(null);

    const openDownload = Boolean(dropdownEl);

    const handleDownloadClick = (e) => {
        setDropdownEl(e.currentTarget);
    };

    const handleDownloadClose = () => {
        setDropdownEl(null);
    };

    const isRunButtonEnabled = () => {
        if (panelMode === '1') {
            if (showReverse) return revX?.trim().length > 0 && revY?.trim().length > 0
            else return address?.trim().length > 0
        }
        return true;
    };

    const isDownloadButtonEnabled = () => {
        if (panelMode === '1') return downloadOptions.length > 0

        // 파일 업로드의 경우 지오코딩 실행 완료 후 다운로드 가능
        return canDownload;
    };

    const handleRunButtonText = () => {
        if (panelMode === '1') return '검색';
        else if (panelMode === '2' && showReverse) return '리버스 지오코딩 실행';
        return '지오코딩 실행'; 
    };

    let StartIconComponent = null;
    switch (startIconName) {
        case 'SearchIcon':
            StartIconComponent = SearchIcon;
            break;
        case 'PlayArrowRoundedIcon':
            StartIconComponent = PlayArrowRoundedIcon;
            break;
        default:
            break;
    }

    return (
        <Stack
            direction="row"
            spacing={1.5}
            sx={{
                my: 4,
            }}
        >
            <Button
                variant="contained"
                size="large"
                onClick={handleQuery}
                fullWidth
                // startIcon={<SearchIcon />}
                startIcon={StartIconComponent ? <StartIconComponent /> : null}
                sx={{
                    mt: 0.5,
                    height: 40,
                    fontWeight: 700,
                    bgcolor: colors.darkBlue,
                    boxShadow: 'none',
                    '&:hover': { 
                        bgcolor: colors.primaryBlue,
                        boxShadow: 'none',
                    },
                    whiteSpace: 'nowrap',
                }}
                disabled={!isRunButtonEnabled()}
            >
                {handleRunButtonText()} 
            </Button>

            <Button
                variant="outlined"
                size="large"
                fullWidth
                onClick={handleDownloadClick}
                // disabled={downloadOptions.length === 0}
                disabled={!isDownloadButtonEnabled()}
                aria-controls={openDownload ? 'download-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openDownload ? 'true' : undefined}
                startIcon={<FileDownloadIcon />}
                endIcon={openDownload ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                disableTouchRipple
                sx={{
                    mt: 0.5,
                    height: 40,
                    color: geoConfig.themeColor,
                    fontWeight: 700,
                    bgcolor: 'white',
                    border: `1px solid ${colors.darkBlue}`,
                    boxShadow: 'none',
                    cursor: 'pointer',
                    '&:hover': { 
                        bgcolor: '#f1f8fb', 
                        boxShadow: 'none', 
                        cursor: 'pointer', 
                    },
                    '&.Mui-disabled': {
                        bgcolor: 'white', 
                        color: colors.lightGray,
                        borderColor: 'rgba(0, 0, 0, 0.26)',
                    },
                    ...(openDownload && {
                        bgcolor: '#f1f8fb',
                    }),
                    whiteSpace: 'nowrap',
                }}
            >
                파일 다운로드
            </Button>
            
            <Menu
                id="download-menu"
                anchorEl={dropdownEl}
                open={openDownload}
                onClose={handleDownloadClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                disableEnforceFocus={true}
                disableAutoFocus={true}
                disableRestoreFocus={true}
                disableScrollLock={true}
                slotProps={{
                    paper: { // Paper 컴포넌트에 적용될 스타일
                        sx: {
                            border: `1px solid ${colors.darkBlue}`, 
                            boxShadow: 'none', 
                            width: dropdownEl ? `${dropdownEl.offsetWidth - 2}px` : 'auto', 
                            mt: 0.5, 
                        },
                    },
                }}
                // ListStyle (MenuItem 간격 조정)
                MenuListProps={{
                    sx: {
                        padding: 0,
                    },
                }}
            >
                {downloadOptions.map((opt) => (
                    <MenuItem 
                        key={opt.value} 
                        onClick={() => handleDownloadItemClick(opt.value)}
                        disabled={opt.disabled}
                        sx={{
                            py: '10px',
                            px: 2,
                            fontSize: '14px',
                            color: geoConfig.themeColor,
                            fontWeight: 600,
                            '&:hover': {
                                bgcolor: '#EBF6FF',
                            },
                        }}
                    >
                        {opt.label}
                    </MenuItem>
                ))}
            </Menu>
        </Stack>
    );
};

export default SearchAndDownloadButtons;